import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import QRCode from 'qrcode';
import { Ic } from '../icons';

const PUBLIC_ORIGIN = (process.env.REACT_APP_PUBLIC_URL || 'https://cybersportleague.kz').replace(/\/$/, '');

export const tournamentPublicUrl = (tourId) => `${PUBLIC_ORIGIN}/#tournament/${encodeURIComponent(tourId)}`;

export default function TournamentQrModal({ open, onClose, tourId, title, lang = 'ru' }) {
  const [dataUrl, setDataUrl] = useState('');
  const [copied, setCopied] = useState(false);
  const url = tournamentPublicUrl(tourId);
  const kz = lang === 'kz';

  useEffect(() => {
    if (!open || !tourId) return undefined;
    let live = true;
    QRCode.toDataURL(url, {
      width: 1200,
      margin: 3,
      errorCorrectionLevel: 'H',
      color: { dark: '#09090c', light: '#ffffff' },
    }).then((value) => { if (live) setDataUrl(value); });
    const key = (event) => { if (event.key === 'Escape') onClose(); };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', key);
    return () => {
      live = false;
      document.body.style.overflow = '';
      window.removeEventListener('keydown', key);
    };
  }, [open, tourId, url, onClose]);

  if (!open) return null;
  const filename = `qr-${String(title || tourId).toLowerCase().replace(/[^a-zа-яё0-9]+/gi, '-').replace(/^-|-$/g, '') || 'tournament'}.png`;
  const copy = async () => {
    await navigator.clipboard?.writeText(url);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return createPortal(
    <div className="tour-qr-backdrop" role="dialog" aria-modal="true" aria-label={kz ? 'Турнирдің QR коды' : 'QR-код турнира'} onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <section className="tour-qr-modal">
        <button className="tour-qr-close" onClick={onClose} aria-label={kz ? 'Жабу' : 'Закрыть'}><Ic name="x" size={22} /></button>
        <header>
          <span><i />{kz ? 'Тұрақты сілтеме' : 'Постоянная ссылка'}</span>
          <h2>{kz ? 'Турнирдің QR коды' : 'QR-код турнира'}</h2>
          <p>{title}</p>
        </header>
        <div className="tour-qr-image">
          {dataUrl ? <img src={dataUrl} alt={kz ? 'Турнир бетіне QR код' : 'QR-код на страницу турнира'} /> : <span>{kz ? 'Жасалуда…' : 'Создаём…'}</span>}
          <b>CYBERSPORTLEAGUE.KZ</b>
        </div>
        <p className="tour-qr-note">{kz ? 'Кодтың мерзімі аяқталмайды және әрқашан осы турнирдің бетіне апарады.' : 'Код не имеет срока действия и всегда ведёт на страницу этого турнира.'}</p>
        <div className="tour-qr-url"><span>{url}</span><button onClick={copy}><Ic name={copied ? 'check' : 'clip'} size={17} />{copied ? (kz ? 'Көшірілді' : 'Скопировано') : (kz ? 'Көшіру' : 'Копировать')}</button></div>
        <a className="tour-qr-download" href={dataUrl || undefined} download={filename} aria-disabled={!dataUrl}><Ic name="download" size={20} />{kz ? 'QR кодты жүктеу' : 'Скачать QR-код'}</a>
      </section>
    </div>,
    document.body,
  );
}
